import { useParams } from "react-router-dom";
import BackButton from "../../../components/common/backbutton/BackButton";
import Images from "../../../media/images";

const MorePhotos = ({ hello }) => {
  const param = useParams();
  console.log(param);
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="exampleModalGallery"
        tabIndex={-1}
        aria-labelledby="exampleModalGallery"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
          <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
            <div className="flex justify-end">
              <svg
                data-bs-dismiss="modal"
                aria-label="Close"
                className="text-primary-blue h-8 w-8"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                />
              </svg>
              <div className="">
                <BackButton />
                <div className="text-center">
                  <h1 className="title-style capitalize">
                    {param?.slug.replace("-", " ")}
                  </h1>
                  <div className="mt-4">
                    <img src={Images.title_border} alt="" className="mx-auto" />
                  </div>
                </div>
                {/*photo cards */}
                {/* <div className="px-10">
          <div className="px-10 py-10">
            <div className="grid grid-cols-1 items-center justify-center gap-7 text-white sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              <card
                data-bs-toggle="modal"
                data-bs-target="#photosModal"
                className="card-div"
              >
                <div>
                  <img
                    alt=""
                    src="https://cdn.britannica.com/67/19367-050-885866B4/Valley-Taurus-Mountains-Turkey.jpg"
                    className="h-2/3 w-full"
                  />
                </div>
                <div className="px-2 py-3">
                  <p className="text-lg font-semibold">Mountian</p>
                </div>
              </card>
            </div>
          </div>
        </div> */}
                {/* cards end here */}

                <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
                  <h5
                    className="text-primary-red -mt-5 text-center text-2xl font-bold"
                    id="exampleModalXlLabel"
                  >
                    तपाईले गर्नुभएको फाईल हाम्रो कर्मचारीहरुले हेर्दै हुनुहुन्छ
                    ।
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MorePhotos;
